<template>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="8" md="4">
      <SessionForm @submit="onSignup" text="Cadastrar" />
    </v-col>
  </v-row>
</template>

<script>
import UserRepository from "@/repositories/UserRepository";
import SessionForm from "@/components/forms/SessionForm";
export default {
  components: {
    SessionForm
  },
  data() {
    return {};
  },
  methods: {
    async onSignup(form) {
      let response = await UserRepository.create(form);

      const loginResponse = await UserRepository.login(form);
      const token = loginResponse.headers.authorization;

      localStorage.setItem("usr_tkn", token);
      if (token) this.$router.push("/");
    }
  }
};
</script>
